module.exports = __webpack_public_path__ + "media/assets/img/portrait/small/avatar-s-3-7ed1da4ad8611b35f46c43992d08833d.jpg";